import { AnyAction, combineReducers, Reducer } from "redux";
import { RootState } from "../store/types";

import uiState from "./uistate";
import glideAppState, { templateStoreState } from "./GlideAppState";
import { panic } from "common/Support";
import userDataReducer from "./user-data";
import tablesState from "./tables-state";
import { newComponentReducer } from "./new-components-state";
import organizationsReducer, { organizationsLoadedReducer } from "./organizations";
import tilesState from "./tile-descriptions-state";
import templateSubmissionsState from "./template-submissions-state";
import notebookState from "./notebook-state";
import searchState from "./search-state";
import pasteboardState from "./pasteboard-state";

function wrapReducer(wrappee: Reducer): Reducer {
    function r(state: any, action: any) {
        if (state === undefined) return null;
        return wrappee(state, action);
    }
    return r;
}

const reducer = combineReducers({
    apps: wrapReducer(glideAppState),
    uiState: wrapReducer(uiState),
    userData: wrapReducer(userDataReducer),
    organizations: wrapReducer(organizationsReducer),
    organizationsLoaded: wrapReducer(organizationsLoadedReducer),
    tables: wrapReducer(tablesState),
    tiles: wrapReducer(tilesState),
    newComponents: wrapReducer(newComponentReducer),
    templateSubmissions: wrapReducer(templateSubmissionsState),
    templateStore: wrapReducer(templateStoreState),
    notebook: wrapReducer(notebookState),
    search: wrapReducer(searchState),
    pasteboard: wrapReducer(pasteboardState),
});

export function rootState(state: RootState | undefined, action: AnyAction): RootState {
    if (state === undefined) {
        return panic("root state must not be undefined");
    }
    return reducer(state, action);
}
